export const HARD_DELETE_ATTACHMENTS = true;
export const APPLICATION_ANALYTICS_DETAILS_REFERRER = 'Application Analytics Details';
